module.exports = "images/directs.231cf6c5.png";